import { SortDirection } from "src/constants/sort-direction";
import { ISortDirectionType } from "src/types/common";
import { SearchQueryParams } from "../search.types";

export const mapSortDirectionFromQuery = (sortDirection: string): ISortDirectionType => (sortDirection === SortDirection.Descending ? 1 : 0);

export const mapSortDirectionToQuery = (sortDirection: ISortDirectionType) => {
    if (sortDirection === null) {
        return "";
    }

    const directionName = sortDirection === 1 ? SortDirection.Descending : SortDirection.Ascending;
    return `${SearchQueryParams.SortDirection}=${directionName}`;
};
